import { Link } from "gatsby"
import React from "react"
import { Link as ScrollLink } from "react-scroll"

import { Container, Row, Col } from "react-bootstrap"
import { ArrowRight } from "react-feather"

const Cta = () => (
    <Container className="cta-container">
        <Row className="cta">

            <Col className="cta-left" md="12" lg="12" style={{ textAlign: 'center' }}>
                <span className="small-description">Getting data from the web has never been easier</span>
                <h2 className="cta-title" style={{ textAlign: 'center' }}>What can I do with the ScrapeOwl API?</h2>
                <ScrollLink to="try-me" className="cta-button" spy={true} hashSpy={true} smooth={true} offset={90} duration={500}>
                    Try the API
                </ScrollLink>
                <Link to="/docs" className="secondary-button">Read the Docs <ArrowRight className="titular-arrow" /></Link>
            </Col>

            {
                /*<Col className="cta-right" md="5" lg="5">
            </Col>*/
            }
        </Row>
    </Container>
)

export default Cta
